/**
 * Helper function that appends a search params to a given URL.
 */
export const appendSearchParamsToURL = (
  url: string,
  params?: Record<string, number | string | undefined>
) => {
  const urlObj = new URL(url);
  if (params)
    Object.entries(params).forEach(([key, value]) => {
      if (value != null) urlObj.searchParams.set(key, value.toString());
    });
  return urlObj.toString();
};
